import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class IconGeneric extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    title: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.string
  };

  render() {
    const { color, size } = this.props;
    const varClass = {
      [`icon__${color}`]: color,
      [`icon__${size}`]: size
    };
    const iconClassName = classNames(
      'icon',
      `icon--${this.props.name}`,
      varClass
    );

    if (this.props.name === 'twin-beds') {
      return (
        <span>
          <i className="icon icon--single-bed" title={this.props.title} />
          <span className="icon--counter">2 </span>
        </span>
      );
    }
    return <i className={iconClassName} title={this.props.title} />;
  }
}

export default IconGeneric;
